import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import {format} from 'date-fns'
import * as queryString from 'query-string'
import ru from 'date-fns/locale/ru'
import { toMoneyFormat } from '../../../tools/number'
import TimeConstant from 'constants/Time'

import InstantBookingStore from 'stores/InstantBookingStore'
import RouteStore from 'stores/RouteStore'
import CargosStore from 'stores/CargosStore'
import ParametersStore from 'stores/ParametersStore'
import UserStore from 'stores/UserStore'

import Card from 'components/InstantBookingFinalInfo/Card'
import ConsultBlock from 'components/ConsultBlock'
import SidebarInfoBlock from 'components/SidebarInfoBlock'
import InfoBlockRoute from 'components/InfoBlockRoute'
import InfoBlockStuff from 'components/InfoBlockStuff'
import InfoBlockParameters from 'components/InfoBlockParameters'

import './SuccessScreen.scss'
import {capitalize} from 'lodash'
import Cookies from 'js-cookie'
import {INSTANT_PRICES_TYPE_NAMES} from "../../constants/Instantprices";


function getStateFromStores() {
    return {
        price: InstantBookingStore.getPrice(),
        distance: InstantBookingStore.getDistance(),
        locations: RouteStore.getLocations(),
        dates: RouteStore.getDates(),
        time: RouteStore.getTime(),
        stuff: CargosStore.getDeliveryCargos(),
        totalWeight: CargosStore.getTotalWeight(),
        totalVolume: CargosStore.getTotalVolume(),
        parameters: ParametersStore.getDeliveryParameters(),
        user: UserStore.getUser(),
        selectedPaymentType: InstantBookingStore.getSelectedPaymentTypeName(),
    }
}

class SuccessScreen extends Component {
    constructor(props) {
        super(props)
        const storeStates = getStateFromStores()

        this.state = {
            ...storeStates,
        }

        this.device = 'desktop'
    }

    componentWillMount() {
        let w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth

        if (w <= 1024 && w >= 320) {
            this.device = 'mobile'
        }
    }

    componentDidMount() {
        InstantBookingStore.addChangeListener(this._onChange)

        if (window.ym) {
            const oid = this.returnOrderID()
            const c = Cookies.get(`reachGoalInstantBookingPayment${oid}`)

            if (!c) {
                window.ym('1315865', 'reachGoal', 'instant_booking_payment', {
                    calendar_payed_uid: this.state.user.id.value,
                    calendar_payed_order_id: oid,
                    order_price: parseInt(this.state.price, 10),
                    currency: 'RUB',
                }, () => {
                    Cookies.set(`reachGoalInstantBookingPayment${oid}`, 1);
                });
            }
        }
    }

    componentWillUnmount() {
        InstantBookingStore.removeChangeListener(this._onChange)
    }

    _onChange = () => {
        this.setState(getStateFromStores())
    }

    returnOrderID = () => {
        const query = queryString.parse(window.location.search)
        const orderId = query.oid ? parseInt(query.oid, 10) : 0

        if (orderId > 0) {
            return orderId
        }

        return '000000'
    }

    returnInvoiceID = () => {
        const query = queryString.parse(window.location.search)
        const invoiceId = query.iid ? parseInt(query.iid, 10) : 0

        if (invoiceId > 0) {
            return invoiceId
        }

        return '000000'
    }

    renderDates = () => {
        // return 'Среда, 25.09.18 с 17:30 до 18:00'

        let finalDateParts = []
        let timeStr = ''

        if (this.state.dates.from) {
            finalDateParts.push(format(this.state.dates.from, 'dddd, DD MMMM YYYY', {locale: ru}))
        }

        if (this.state.dates.to && this.state.dates.from !== this.state.dates.to) {
            finalDateParts.push(format(this.state.dates.to, 'dddd, DD MMMM YYYY', {locale: ru}))
        }

        if (this.state.time && this.state.time.from) {
            timeStr = `c ${TimeConstant.Hours[this.state.time.from].label}`

            if (this.state.time.to) {
                timeStr += ` до ${TimeConstant.Hours[this.state.time.to].label}`
            }
        }

        return capitalize(finalDateParts.join('–')) + ' ' + timeStr
    }

    returnRoute(locations, type) {
        let result = ''

        switch (type) {
            case 'from':
                if (locations.from && locations.from[0]) {
                    result = locations.from[0].text
                }
                break

            case 'to':
                if (locations.to && locations.to[0]) {
                    result = locations.to[0].text
                }

                if (locations.to && locations.to[1]) {
                    result = locations.to[1].text
                }
                break
            default:
                break
        }

        return result
    }

    renderHeader() {
        let header = ''

        switch (this.state.selectedPaymentType) {
            case 'payment_online':
                header = 'Оплата прошла успешно'
                break
            case 'payment_invoice':
            case 'payment_cash':
                header = 'Бронирование завершено'
                break
            default:
                header = 'Бронирование завершено'
                break
        }

        return header
    }

    renderSubHeader() {
        let subHeader = ''

        switch (this.state.selectedPaymentType) {
            case 'payment_invoice':
                subHeader = (
                    <span>
                        Выставленный счет доступен по <a href={`/invoices/${this.returnInvoiceID()}`} target="_blank">ссылке</a>. Как только вы произведете оплату, пришлите закрывающие документы на <b>b2c@vezetvsem.ru</b>. После подтверждения оплаты в рабочее время с вами свяжется менеджер по телефону или почте уточнит заказ и система назначит водителя, если заказ срочный, назначение произойдет автоматически.
                    </span>
                )
                break
            case 'payment_cash':
            case 'payment_online':
                subHeader = 'В рабочее время с вами свяжется менеджер по телефону или почте уточнит заказ и система назначит водителя, если заказ срочный, назначение произойдет автоматически.'
                break
            default:
                subHeader = 'В рабочее время с вами свяжется менеджер по телефону или почте уточнит заказ и система назначит водителя, если заказ срочный, назначение произойдет автоматически.'
                break
        }

        return subHeader
    }

    renderDesktop() {
        return (
            <div>
                <section className="Success container">
                    <div className="Success-wrapper">
                        <main className="Success-content">
                            <h1 className="heading">
                                <IconSVG
                                    className="heading-icon"
                                    src={require('!svg-inline!./check_green.svg')} />
                                {this.renderHeader()}
                            </h1>
                            <h3 className="heading">Номер вашего заказа <b>{this.returnOrderID()}</b>.</h3>
                            <h3 className="heading">{this.renderSubHeader()}</h3>
                            {this.state.selectedPaymentType === 'payment_invoice' ?
                                <h3 className="heading">Предварительный договор можно посмотреть по <a href={`/guarantee_blank/show_legal_ib_contract?oid=${this.returnOrderID()}`} target="_blank">ссылке</a>. Финальный договор на перевозку и контакты водителя будут направлены вам в SMS и на электронную почту.</h3> :
                                <h3 className="heading">Финальный договор на перевозку и контакты водителя будут направлены вам в SMS и на электронную почту.</h3>}
                            <div className="Success-features">
                                <Card
                                    text="Гарантии неизменности цены"
                                    svgPath="shield.svg" />
                                <Card
                                    text="Возврат всех денег при отмене перевозки за 8 часов до погрузки"
                                    svgPath="money.svg" />
                                <Card
                                    text="Обязательный звонок менеджера для уточнения подробностей предстоящей перевозки"
                                    svgPath="headphones.svg" />
                                <Card
                                    text="Фиксирование всех деталей перевозки в договоре"
                                    svgPath="contract.svg" />
                            </div>
                            <ConsultBlock/>
                        </main>

                        <aside className="Success-sidebar">
                            <SidebarInfoBlock title="Дата и время">
                                {this.renderDates()}
                            </SidebarInfoBlock>

                            <SidebarInfoBlock title={this.state.distance ? `Маршрут (${this.state.distance} км)` : 'Маршрут'}>
                                <InfoBlockRoute
                                    locations={this.state.locations} />
                            </SidebarInfoBlock>

                            <SidebarInfoBlock title="Ваши грузы">
                                <InfoBlockStuff
                                    stuff={this.state.stuff}
                                    totalWeight={this.state.totalWeight}
                                    totalVolume={this.state.totalVolume} />
                            </SidebarInfoBlock>

                            <SidebarInfoBlock title="Дополнительные услуги">
                                <InfoBlockParameters parameters={this.state.parameters} />
                            </SidebarInfoBlock>

                            <div className="Success-finalPrice">
                                Итоговая цена: {`${toMoneyFormat(this.state.price)}₽`}
                            </div>
                        </aside>
                    </div>
                </section>
            </div>
        )
    }

    _renderMobile() {
        return (
            <div>
                <section className="Success container">
                    <div className="Success-wrapper">
                        <main className="Success-content">
                            <h1 className="heading">
                                <IconSVG
                                    className="heading-icon"
                                    src={require('!svg-inline!./check_green.svg')} />
                                {this.renderHeader()}
                            </h1>
                            <h3 className="heading">{this.renderSubHeader()}</h3>
                            {this.state.selectedPaymentType === 'payment_invoice' ?
                                <h3 className="heading" style={{ marginTop: '20px' }}>Предварительный договор можно посмотреть по <a href={`/guarantee_blank/show_legal_ib_contract?oid=${this.returnOrderID()}`} target="_blank">ссылке</a>. Финальный договор на перевозку и контакты водителя будут направлены вам в SMS и на электронную почту.</h3> :
                                <h3 className="heading" style={{ marginTop: '20px' }}>Финальный договор на перевозку и контакты водителя будут направлены вам в SMS и на электронную почту.</h3> }
                            {/* Отображается только в мобильных */}
                            <div className="mobileBlock-finalPrice">
                                <span>
                                    Итоговая цена: {`${toMoneyFormat(this.state.price)}₽`}
                                </span>
                            </div>

                            {/* Отображается только в мобильных */}
                            <div className="mobileBlock-orderInfo">
                                <span>
                                    Номер вашего заказа {this.returnOrderID()}
                                </span>
                            </div>

                            {/* Отображается только в мобильных */}
                            <div className="mobileBlock-orderDescription">
                                <ul className="orderDescription__list">
                                    <li className="orderDescription__item">
                                        <span className="highlighted">Маршрут</span>
                                        <span>{this.returnRoute(this.state.locations, 'from')} -> {this.returnRoute(this.state.locations, 'to')}</span>
                                    </li>
                                    <li className="orderDescription__item">
                                        <span className="highlighted">Дата и время</span>
                                        <span>{this.renderDates()}</span>
                                    </li>
                                    <li className="orderDescription__item">
                                        <span className="highlighted">Доп. услуги</span>
                                        {this.state.stuff.map((item, index) => (
                                            <span key={index}>{item.get('name')}</span>
                                        ))}
                                    </li>
                                    <li className="orderDescription__item">
                                        <span className="highlighted">Всего грузов</span>
                                        <span>{this.state.stuff.size} шт.</span>
                                    </li>
                                    <li className="orderDescription__item">
                                        <span className="highlighted">Общий объём</span>
                                        <span>{this.state.totalVolume} м³</span>
                                    </li>
                                    <li className="orderDescription__item">
                                        <span className="highlighted">Общий вес</span>
                                        <span>{this.state.totalWeight} кг.</span>
                                    </li>
                                </ul>
                            </div>

                            <section className="orderBlock">
                                <header className="orderBlock-header">
                                    <h2 className="heading">
                                        Номер вашего заказа {this.returnOrderID()}
                                    </h2>
                                </header>

                                <main className="orderBlock-main">
                                    <div className="orderBlock-main-column">
                                        <div className="highlighted">Маршрут</div>
                                        <div>
                                            {this.returnRoute(this.state.locations, 'from')} - {this.returnRoute(this.state.locations, 'to')}
                                        </div>
                                        <div className="highlighted">Дата и время</div>
                                        <div>
                                            <span>{format(this.state.dates.from, 'dddd', { locale: ru })}, </span>
                                            <span>{format(this.state.dates.from, 'DD.MM.YYYY', { locale: ru })} </span>
                                            <span> / </span>
                                            <span>
                                                c {format(this.state.dates.from, 'hh:mm', { locale: ru })} до {format(this.state.dates.to, 'hh:mm', { locale: ru })}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="orderBlock-main-column">
                                        <span className="highlighted">Доп. услуги</span>
                                        <ul className="orderBlock-list">
                                            {this.state.stuff.map((item, index) => {
                                                const key = `orderBlock-item-${index}`

                                                return (
                                                    <li key={key}>
                                                        {item.get('name')}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </main>

                                <footer className="orderBlock-footer">
                                    <div className="orderBlock-footer-left">
                                        <div>
                                            <span className="highlighted">Всего грузов</span>
                                            <span>{this.state.stuff.size} шт.</span>
                                        </div>

                                        <div>
                                            <span className="highlighted">Общий объем</span>
                                            <span>{this.state.totalVolume} м³</span>
                                        </div>

                                        <div>
                                            <span className="highlighted">Общий вес</span>
                                            <span>{this.state.totalWeight} кг.</span>
                                        </div>
                                    </div>

                                    <div className="orderBlock-footer-right">
                                        <span>
                                            Итоговая цена: {`${toMoneyFormat(this.state.price)}₽`}
                                        </span>
                                    </div>
                                </footer>
                            </section>

                            <div className="Success-features">
                                <Card
                                    text="Гарантии неизменности цены"
                                    svgPath="shield.svg"/>
                                <Card
                                    text="Возврат всех денег при отмене перевозки за 8 часов до погрузки"
                                    svgPath="money.svg"/>
                                <Card
                                    text="Обязательный звонок менеджера для уточнения подробностей предстоящей перевозки"
                                    svgPath="headphones.svg"/>
                                <Card
                                    text="Фиксирование всех деталей перевозки в договоре"
                                    svgPath="contract.svg"/>
                            </div>
                            <ConsultBlock/>
                        </main>
                    </div>
                </section>
            </div>
        )
    }

    render() {
        if (this.device === 'desktop') {
            return this.renderDesktop()
        }

        if (this.device === 'mobile') {
            return this._renderMobile()
        }
    }
}

export default SuccessScreen



// WEBPACK FOOTER //
// ./client/components/SuccessScreen/SuccessScreen.js